import React from 'react';

export type StopPropagationArgs = {
	preventDefault?: boolean;
};

export const stopPropagation = <E extends React.SyntheticEvent | Event>(
	event: E,
) => {
	event.stopPropagation();
	event.preventDefault();
};

export default stopPropagation;
